import { placedDecimal, roundToPlaces } from './scaled';

/**
 * Base units rounded half up to at most `maxFraction` places, at least
 * `minFraction`, grouped: `formatUnitsFixed(1234567891n, 6, { maxFraction: 4 })`
 * reads "1,234.5679". The bigint counterpart of
 * `Intl.NumberFormat({ minimumFractionDigits, maximumFractionDigits })`,
 * with the same output for every amount a double can hold exactly and the
 * right one for those it cannot. A negative amount carries a hyphen, as
 * `Intl` prints it.
 */
export function formatUnitsFixed(
  raw: bigint,
  decimals: number,
  {
    maxFraction,
    minFraction = 0
  }: { maxFraction: number; minFraction?: number }
): string {
  if (raw < 0n) {
    return `-${formatUnitsFixed(-raw, decimals, { maxFraction, minFraction })}`;
  }
  const scaled = roundToPlaces(raw, decimals, maxFraction);
  return placedDecimal(scaled, maxFraction, minFraction);
}
